import axios from 'axios';

// Set Axios base URL
axios.defaults.baseURL = 'https://thinktankapi.multichoice.com/'; // Replace with your API base URL

// Add a request interceptor to attach the Authorization token
axios.interceptors.request.use((config) => {
    const token = localStorage.getItem('userToken'); // Retrieve token from localStorage
    if (token) {
        config.headers.Authorization = `${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

// Add a response interceptor for global error handling (optional)
axios.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error.response && error.response.status === 401) {
        console.error('Unauthorized access. Please log in again.');
        localStorage.removeItem('userToken'); // Clear the token
        window.location.href = '/#/login'; // Redirect to login page
    }
    return Promise.reject(error);
});

export default axios; // Export Axios to use anywhere if needed


// WEBPACK FOOTER //
// ./src/helpers/axios-config.js